import { Col, FormGroup, FormLabel, OverlayTrigger, Tooltip } from "react-bootstrap";
import { defineMessages, FormattedMessage } from "react-intl";
import React, { memo, useEffect, useState } from "react";
import { UseFormReturn } from "react-hook-form";
import { InsuranceEntity, InsuranceTaxationEntity } from "../../entity";
import { CustomTaxation } from "../../../taxation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import { useTaxation } from "../../../taxation/taxation.hook";

const messages = defineMessages({
  taxes: { id: "insurance.form.taxes", defaultMessage: "Taxes" },
  fees: { id: "insurance.form.fees", defaultMessage: "Fees" },
  taxationInactive: {
    id: "insurance.form.taxationInactive",
    defaultMessage: " Currently inactive",
  },
});

export const TaxationComponent = memo((props: UseFormReturn<InsuranceEntity>) => {
  const { onGetAllTax, onGetAllFee } = useTaxation();

  const [taxes, setTaxes] = useState<CustomTaxation[]>([]);
  const [fees, setFees] = useState<CustomTaxation[]>([]);

  const selectedTaxes = props.watch("taxes") || [];
  const selectedFees = props.watch("fees") || [];

  useEffect(() => {
    onGetAllTax().then(response => setTaxes(response));
  }, [onGetAllFee, onGetAllTax, setFees, setTaxes]);

  useEffect(() => {
    onGetAllFee().then(response => setFees(response));
  }, [onGetAllFee, setFees]);

  const handleTaxChange = (tax: InsuranceTaxationEntity, checked: boolean) => {
    const current = selectedTaxes || [];
    if (checked) {
      props.setValue("taxes", [...current, tax]);
    } else {
      props.setValue(
        "taxes",
        current.filter(it => it.id !== tax.id)
      );
    }
  };

  const handleFeeChange = (fee: InsuranceTaxationEntity, checked: boolean) => {
    const current = selectedFees || [];
    if (checked) {
      props.setValue("fees", [...current, fee]);
    } else {
      props.setValue(
        "fees",
        current.filter(it => it.id !== fee.id)
      );
    }
  };

  return (
    <>
      {taxes.length > 0 && (
        <FormGroup as={Col}>
          <FormLabel column sm={12} className="font-weight-bold">
            <FormattedMessage {...messages.taxes} />
          </FormLabel>
          <Col sm={4} className="flex flex-col">
            {taxes.map(tax => (
              <div className="flex-row witadmin-bs3" key={`tax-${tax.ticker}`}>
                <FormGroup>
                  <div className="checkbox c-checkbox needsclick">
                    <label className="needsclick control-label" htmlFor={`tax-${tax.id}`}>
                      <input
                        type="checkbox"
                        id={`tax-${tax.id}`}
                        className="needsclick"
                        value={tax.id}
                        checked={selectedTaxes.some(it => it.id === tax.id)}
                        onChange={e => handleTaxChange(tax, e.target.checked)}
                      />
                      <em className="fa fa-check" />
                      {tax.ticker}
                      {!tax.active && (
                        <span className="ml-1">
                          <OverlayTrigger
                            delay={{ show: 250, hide: 0 }}
                            overlay={props => (
                              <Tooltip id={`tax-tooltip-${tax.id}`} {...props}>
                                <FormattedMessage {...messages.taxationInactive} />
                              </Tooltip>
                            )}>
                            <FontAwesomeIcon icon={faWarning} />
                          </OverlayTrigger>
                        </span>
                      )}
                    </label>
                  </div>
                </FormGroup>
              </div>
            ))}
          </Col>
        </FormGroup>
      )}

      {fees.length > 0 && (
        <FormGroup as={Col}>
          <FormLabel column sm={12} className="font-weight-bold">
            <FormattedMessage {...messages.fees} />
          </FormLabel>
          <Col sm={4} className="flex flex-col">
            {fees.map(fee => (
              <div className="flex-row witadmin-bs3" key={`fee-${fee.ticker}`}>
                <FormGroup>
                  <div className="checkbox c-checkbox needsclick">
                    <label className="needsclick control-label" htmlFor={`fee-${fee.id}`}>
                      <input
                        type="checkbox"
                        id={`fee-${fee.id}`}
                        className="needsclick"
                        value={fee.id}
                        checked={selectedFees.some(it => it.id === fee.id)}
                        onChange={e => handleFeeChange(fee, e.target.checked)}
                      />
                      <em className="fa fa-check" />
                      {fee.ticker}
                      {!fee.active && (
                        <span className="ml-1">
                          <OverlayTrigger
                            delay={{ show: 250, hide: 0 }}
                            overlay={props => (
                              <Tooltip id={`fee-tooltip-${fee.id}`} {...props}>
                                <FormattedMessage {...messages.taxationInactive} />
                              </Tooltip>
                            )}>
                            <FontAwesomeIcon icon={faWarning} />
                          </OverlayTrigger>
                        </span>
                      )}
                    </label>
                  </div>
                </FormGroup>
              </div>
            ))}
          </Col>
        </FormGroup>
      )}
    </>
  );
});
